/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DecisionTopicReport', 'model/DecisionTopicSuggestionSearchItem'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/DecisionTopicReport'), require('../model/DecisionTopicSuggestionSearchItem'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DecisionTopicApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.DecisionTopicReport, root.ForStractionServiceApi.DecisionTopicSuggestionSearchItem);
  }
}(this, function(ApiClient, DecisionTopicReport, DecisionTopicSuggestionSearchItem) {
  'use strict';

  /**
   * DecisionTopic service.
   * @module api/DecisionTopicApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new DecisionTopicApi. 
   * @alias module:api/DecisionTopicApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the decisionTopicAddPut operation.
     * @callback module:api/DecisionTopicApi~decisionTopicAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/DecisionTopicReport} body 
     * @param {module:api/DecisionTopicApi~decisionTopicAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.decisionTopicAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling decisionTopicAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling decisionTopicAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/DecisionTopic/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the decisionTopicDeleteGet operation.
     * @callback module:api/DecisionTopicApi~decisionTopicDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/DecisionTopicApi~decisionTopicDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.decisionTopicDeleteGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling decisionTopicDeleteGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling decisionTopicDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DecisionTopic/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the decisionTopicEditPut operation.
     * @callback module:api/DecisionTopicApi~decisionTopicEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/DecisionTopicReport} body 
     * @param {module:api/DecisionTopicApi~decisionTopicEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.decisionTopicEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling decisionTopicEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling decisionTopicEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DecisionTopic/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the decisionTopicLoadAllGet operation.
     * @callback module:api/DecisionTopicApi~decisionTopicLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/DecisionTopicReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {module:api/DecisionTopicApi~decisionTopicLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/DecisionTopicReport>}
     */
    this.decisionTopicLoadAllGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling decisionTopicLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxCommentsCount': opts['maxCommentsCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [DecisionTopicReport];

      return this.apiClient.callApi(
        '/DecisionTopic/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the decisionTopicLoadGet operation.
     * @callback module:api/DecisionTopicApi~decisionTopicLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DecisionTopicReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {module:api/DecisionTopicApi~decisionTopicLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DecisionTopicReport}
     */
    this.decisionTopicLoadGet = function(_4SAPIAppID, entityID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling decisionTopicLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling decisionTopicLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID,
        'maxCommentsCount': opts['maxCommentsCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = DecisionTopicReport;

      return this.apiClient.callApi(
        '/DecisionTopic/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the decisionTopicPutAsLastInPhaseGet operation.
     * @callback module:api/DecisionTopicApi~decisionTopicPutAsLastInPhaseGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * putAsLastInPhase
     * @param {String} _4SAPIAppID 
     * @param {Integer} editedTopicID 
     * @param {Integer} basePhaseID 
     * @param {module:api/DecisionTopicApi~decisionTopicPutAsLastInPhaseGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.decisionTopicPutAsLastInPhaseGet = function(_4SAPIAppID, editedTopicID, basePhaseID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling decisionTopicPutAsLastInPhaseGet";
      }

      // verify the required parameter 'editedTopicID' is set
      if (editedTopicID == undefined || editedTopicID == null) {
        throw "Missing the required parameter 'editedTopicID' when calling decisionTopicPutAsLastInPhaseGet";
      }

      // verify the required parameter 'basePhaseID' is set
      if (basePhaseID == undefined || basePhaseID == null) {
        throw "Missing the required parameter 'basePhaseID' when calling decisionTopicPutAsLastInPhaseGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'editedTopicID': editedTopicID,
        'basePhaseID': basePhaseID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DecisionTopic/putAsLastInPhase', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the decisionTopicPutBeforeTopicGet operation.
     * @callback module:api/DecisionTopicApi~decisionTopicPutBeforeTopicGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * putBeforeTopic
     * @param {String} _4SAPIAppID 
     * @param {Integer} editedTopicID 
     * @param {Integer} baseTopicID 
     * @param {module:api/DecisionTopicApi~decisionTopicPutBeforeTopicGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.decisionTopicPutBeforeTopicGet = function(_4SAPIAppID, editedTopicID, baseTopicID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling decisionTopicPutBeforeTopicGet";
      }

      // verify the required parameter 'editedTopicID' is set
      if (editedTopicID == undefined || editedTopicID == null) {
        throw "Missing the required parameter 'editedTopicID' when calling decisionTopicPutBeforeTopicGet";
      }

      // verify the required parameter 'baseTopicID' is set
      if (baseTopicID == undefined || baseTopicID == null) {
        throw "Missing the required parameter 'baseTopicID' when calling decisionTopicPutBeforeTopicGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'editedTopicID': editedTopicID,
        'baseTopicID': baseTopicID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DecisionTopic/putBeforeTopic', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the decisionTopicSuggestGet operation.
     * @callback module:api/DecisionTopicApi~decisionTopicSuggestGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/DecisionTopicSuggestionSearchItem>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * suggest
     * @param {String} _4SAPIAppID 
     * @param {String} searchString 
     * @param {module:api/DecisionTopicApi~decisionTopicSuggestGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/DecisionTopicSuggestionSearchItem>}
     */
    this.decisionTopicSuggestGet = function(_4SAPIAppID, searchString, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling decisionTopicSuggestGet";
      }

      // verify the required parameter 'searchString' is set
      if (searchString == undefined || searchString == null) {
        throw "Missing the required parameter 'searchString' when calling decisionTopicSuggestGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'searchString': searchString
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [DecisionTopicSuggestionSearchItem];

      return this.apiClient.callApi(
        '/DecisionTopic/suggest', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
